function notifyWebViewLessonTitle(title) {
    // ios, https://stackoverflow.com/a/34575373/1243617
    try {
        window.webkit.messageHandlers.lessonChanged.postMessage(title);
    } catch (error) {
        // not in native iOS webview, ignore
    }

    // android, https://stackoverflow.com/a/10481108/1243617
    try {
        window.AndroidInterface.changeLesson(title);
    } catch (error) {
        // not in native Android webview, ignore
    }
}

export {notifyWebViewLessonTitle};
